import { useEffect, useState } from "react";
import { Driver } from "../models/driver";
import { fetchDrivers } from "../api/fetchDrivers";
import { getFollowersProfiles } from "../api/routing";

export function useDrivers() {
    const [drivers, setDrivers] = useState<Driver[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            const drivers = await fetchDrivers();
            const profiles = await getFollowersProfiles();

            setDrivers([
                ...drivers,
                ...(profiles.profiles?.map((profile) => ({
                    id: profile.id,
                    name: profile.name,
                    type: profile.type,
                    profileId: profile.id
                })) ?? [])
                    // .filter((driver) => driver.type === "DRIVER_RIO")
            ]);
        }
        fetchData();
    }, []);

    return { drivers };
}